import type { ApolloQueryResult } from '@apollo/client';
import { print } from '@apollo/client/utilities';
import { BaseApi } from '@solfacil/plasma-utils';
import type { $Fetch } from 'ofetch';

import {
  UserInfoDocument,
  type User,
  type UserInfoQuery,
} from '~/types/ecommerce/generated.codegen';

export default class UserApi extends BaseApi {
  constructor(api: $Fetch) {
    super(api);
  }

  async getUser(): Promise<User> {
    try {
      const response = await super.api<ApolloQueryResult<UserInfoQuery>>('', {
        method: 'POST',
        body: {
          operationName: 'UserInfo',
          query: print(UserInfoDocument),
          variables: {},
        },
        retry: 3,
        retryDelay: 1000,
      });

      if (!response.data || response.errors) {
        showError({
          message:
            'Erro ao buscar informações do usuário. Tente novamente mais tarde.',
          statusCode: 500,
          data: response.errors,
        });
      }

      return Promise.resolve(response.data.getUser);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
